import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

import { useRightSidebarResize } from "./hooks/use-right-sidebar-resize";

type RightSidebarResizeHandleProps = {
    onWidthChange: (widthPx: number | null) => void;
};

/** Grab bar on the Darwin panel's left edge. Double-click (or Home) goes back to the default width. */
export function RightSidebarResizeHandle({ onWidthChange }: RightSidebarResizeHandleProps) {
    const { t } = useTranslation();
    const resizeHandlers = useRightSidebarResize({ onWidthChange });

    return (
        <div
            role="separator"
            aria-orientation="vertical"
            aria-label={t("resize_darwin_panel")}
            tabIndex={0}
            {...resizeHandlers}
            className={cn(
                "group absolute inset-y-0 left-0 z-20 flex w-2 cursor-col-resize touch-none items-center justify-center",
                "focus-visible:outline-none"
            )}
        >
            <span
                className={cn(
                    "h-12 w-1 rounded-full bg-border opacity-0 transition-opacity duration-150",
                    "group-hover:opacity-100 group-focus-visible:opacity-100 group-active:bg-primary group-active:opacity-100"
                )}
            />
        </div>
    );
}
